import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";

// Fix Leaflet default marker
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

// Saudi cities coordinates
export const CITY_COORDS = {
  Riyadh: [24.7136, 46.6753],
  Jeddah: [21.4858, 39.1925],
  Makkah: [21.3891, 39.8579],
  Madinah: [24.4677, 39.6111],
  Dammam: [26.4207, 50.0888],
  Taif: [21.2703, 40.4158],
  Thaif: [21.2703, 40.4158],
  "Al Ula": [26.6086, 37.9236],
  "Bandara Jeddah": [21.6796, 39.1565],
  "Bandara Madinah": [24.5534, 39.7051],
  Tabuk: [28.3835, 36.5662],
  Abha: [18.2164, 42.5053],
};

export default function TripMap({ origin, destination, current, height = 480 }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setTick((x) => x + 1), 200);
    return () => clearTimeout(t);
  }, []);

  const o = CITY_COORDS[origin] || [24.7136, 46.6753];
  const d = CITY_COORDS[destination] || [21.4858, 39.1925];
  const c = current && current.lat && current.lng ? [current.lat, current.lng]
                                                   : [(o[0] + d[0]) / 2, (o[1] + d[1]) / 2];
  const center = [(o[0] + d[0]) / 2, (o[1] + d[1]) / 2];

  return (
    <div style={{ height }} className="rounded-2xl overflow-hidden border border-slate-200" data-testid="trip-map">
      <MapContainer center={center} zoom={6} style={{ height: "100%", width: "100%" }} key={tick}>
        <TileLayer attribution='&copy; OpenStreetMap contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={o}><Popup>Origin: {origin}</Popup></Marker>
        <Marker position={d}><Popup>Destination: {destination}</Popup></Marker>
        <Marker position={c}><Popup>Current Location</Popup></Marker>
        <Polyline positions={[o, c, d]} pathOptions={{ color: "#059669", weight: 4, dashArray: "10 8" }} />
      </MapContainer>
    </div>
  );
}
